import { Controller } from '@hotwired/stimulus'
import SmoothScroll from 'smooth-scroll'

export default class extends Controller {
  static targets = ['fee']

  initialize () {
    this.scroll = new SmoothScroll(null, {
      offset: 55,
      speed: 600,
      speedAsDuration: true,
      easing: 'linear',
      updateURL: false,
      popstate: false,
    })
  }

  scrollTo (id) {
    const anchor = document.querySelector(id)
    this.scroll.animateScroll(anchor)
  }

  scrollOrRedirectToPlans (e) {
    const plansSection = document.getElementById('plans')
    if (plansSection) {
      e.preventDefault()
      this.scrollTo('#plans')
    }
  }

  className () {
    return this.element.dataset.classname
  }

  toggle () {
    if (this.feeTarget.classList.contains(`${this.className()}::hidden`)) {
      this.feeTarget.classList.remove(`${this.className()}::hidden`)
      this.feeTarget.classList.add(`${this.className()}::show`)
    } else {
      this.feeTarget.classList.remove(`${this.className()}::show`)
      this.feeTarget.classList.add(`${this.className()}::hidden`)
    }
  }

  close () {
    this.feeTarget.style.display = 'none'
  }
}
